import {
  BArchive,
  BBell,
  BBookmark,
  BCalendar,
  BCamera,
  BChart,
  BChevronDown,
  BChevronLeft,
  BChevronRight,
  BChevronUp,
  BCog,
  BDots,
  BEmoji,
  BError,
  BFile,
  BGrid,
  BHeart,
  BHome,
  BImage,
  BLink,
  BLock,
  BMail,
  BMap,
  BMenu,
  BMessage,
  BMinus,
  BPlatform,
  BPlus,
  BSearch,
  BSend,
  BShare,
  BShoppingBag,
  BShoppingCart,
  BSocialMedia,
  BStore,
  BThumb,
  BTime,
  BTrash,
  BUser,
  BVideo,
  BX,
  FeArchive,
  FeBell,
  FeBookmark,
  FeCalendar,
  FeCamera,
  FeChart,
  FeChevronDown,
  FeChevronLeft,
  FeChevronRight,
  FeChevronUp,
  FeCog,
  FeDots,
  FeEmoji,
  FeError,
  FeFile,
  FeGrid,
  FeHeart,
  FeHome,
  FeImage,
  FeLink,
  FeLock,
  FeMail,
  FeMap,
  FeMenu,
  FeMessage,
  FeMinus,
  FePlus,
  FeSearch,
  FeSend,
  FeShare,
  FeShoppingBag,
  FeShoppingCart,
  FeThumb,
  FeTime,
  FeTrash,
  FeUser,
  FeVideo,
  FeX,
} from '@fast-base/icons';

export const ICONS = [
  /**
   * BoxIcons section
   */
  {
    pack: 'BoxIcons',
    icons: [
      {
        name: 'chevron-up',
        Component: BChevronUp,
        modes: ['normal', 'double', 'circle', 'square'],
      },
      {
        name: 'chevron-left',
        Component: BChevronLeft,
        modes: ['normal', 'double', 'circle', 'square'],
      },
      {
        name: 'chevron-right',
        Component: BChevronRight,
        modes: ['normal', 'double', 'circle', 'square'],
      },
      {
        name: 'chevron-down',
        Component: BChevronDown,
        modes: ['normal', 'double', 'circle', 'square'],
      },
      {
        name: 'home',
        alternatives: ['house'],
        Component: BHome,
        modes: [
          'normal',
          'fill',
          'alt',
          'alt2',
          'alt2-fill',
          'circle',
          'circle-fill',
          'heart',
          'heart-fill',
          'smile',
          'smile-fill',
        ],
      },
      {
        name: 'search',
        alternatives: ['find'],
        Component: BSearch,
        modes: [
          'normal',
          'fill',
          'alt',
          'alt2',
          'alt2-fill',
          'file',
          'file-fill',
        ],
      },
      {
        name: 'user',
        alternatives: ['person'],
        Component: BUser,
        modes: [
          'normal',
          'fill',
          'circle',
          'circle-fill',
          'plus',
          'minus',
          'x',
          'x-fill',
          'check',
          'check-fill',
          'voice',
          'voice-fill',
          'account',
        ],
      },
      {
        name: 'image',
        Component: BImage,
        alternatives: ['picture'],
        modes: ['normal', 'fill', 'images'],
      },
      {
        name: 'x',
        Component: BX,
        alternatives: ['close', 'block'],
        modes: ['normal', 'circle', 'circle-fill', 'square'],
      },
      {
        name: 'message',
        alternatives: ['chat'],
        Component: BMessage,
        modes: [
          'normal',
          'fill',
          'dots',
          'dots-fill',
          'round',
          'round-fill',
          'square',
          'square-fill',
          'detail',
          'detail-fill',
        ],
      },
      {
        name: 'send',
        Component: BSend,
        modes: ['normal', 'fill'],
      },
      {
        name: 'camera',
        Component: BCamera,
        alternatives: ['capture'],
        modes: ['normal', 'fill', 'off', 'off-fill', 'home', 'home-fill'],
      },
      {
        name: 'video',
        alternatives: ['record'],
        Component: BVideo,
        modes: [
          'normal',
          'fill',
          'off',
          'off-fill',
          'recording',
          'recording-fill',
          'videos',
        ],
      },
      {
        name: 'shopping-bag',
        Component: BShoppingBag,
        alternatives: ['buy', 'sell'],
        modes: ['normal', 'fill', 'alt', 'bags'],
      },
      {
        name: 'shopping-cart',
        Component: BShoppingCart,
        alternatives: ['buy', 'sell'],
        modes: ['normal', 'fill', 'alt', 'alt-fill'],
      },
      {
        name: 'chart',
        alternatives: [
          'stats',
          'bar',
          'pie',
          'doughnut',
          'line',
          'network',
          'scatter',
        ],
        Component: BChart,
        modes: [
          'normal',
          'fill',
          'bar',
          'bar-alt',
          'bar-alt-fill',
          'pie',
          'pie-fill',
          'doughnut',
          'doughnut-fill',
          'line',
          'line-down',
          'network',
          'network-fill',
          'scatter',
        ],
      },
      {
        name: 'time',
        Component: BTime,
        alternatives: ['clock'],
        modes: ['normal', 'fill', 'timer', 'timer-fill'],
      },
      {
        name: 'calendar',
        Component: BCalendar,
        alternatives: ['event', 'date'],
        modes: ['normal', 'fill', 'alt', 'alt-fill', 'event', 'event-fill'],
      },
      {
        name: 'emoji',
        alternatives: ['smile', 'wink', 'sad', 'meh'],
        Component: BEmoji,
        modes: [
          'smile',
          'smile-fill',
          'wink',
          'wink-fill',
          'sad',
          'sad-fill',
          'meh',
          'meh-fill',
        ],
      },
      {
        name: 'bell',
        Component: BBell,
        alternatives: ['alert', 'notification'],
        modes: ['normal', 'fill', 'off', 'off-fill', 'ring'],
      },
      {
        name: 'bookmark',
        alternatives: ['save', 'star'],
        Component: BBookmark,
        modes: [
          'normal',
          'fill',
          'bookmarks',
          'bookmarks-fill',
          'star',
          'star-fill',
        ],
      },
      {
        name: 'file',
        Component: BFile,
        alternatives: ['document', 'pdf', 'archive', 'import', 'png'],
        modes: ['normal', 'fill', 'blank', 'pdf', 'png', 'archive', 'import'],
      },
      {
        name: 'share',
        Component: BShare,
        modes: ['normal', 'fill', 'alt', 'alt-fill'],
      },
      {
        name: 'lock',
        Component: BLock,
        modes: [
          'normal',
          'fill',
          'alt',
          'alt-fill',
          'open',
          'open-fill',
          'open-alt',
          'open-alt-fill',
          'block',
        ],
      },
      {
        name: 'map',
        alternatives: ['location', 'coordinate'],
        Component: BMap,
        modes: [
          'normal',
          'fill',
          'alt',
          'alt-fill',
          'pin',
          'pin-fill',
          'target',
        ],
      },
      {
        name: 'trash',
        Component: BTrash,
        alternatives: ['delete', 'remove'],
        modes: ['normal', 'fill', 'alt', 'alt-fill'],
      },
      {
        name: 'grid',
        Component: BGrid,
        modes: ['normal', 'fill', 'alt', 'alt-fill', 'vertical', 'horizontal'],
      },
      {
        name: 'thumb',
        Component: BThumb,
        alternatives: ['like', 'dislike'],
        modes: ['up', 'up-fill', 'down', 'down-fill'],
      },
      {
        name: 'heart',
        alternatives: ['like', 'donate'],
        Component: BHeart,
        modes: [
          'normal',
          'fill',
          'circle',
          'circle-fill',
          'donate',
          'donate-fill',
        ],
      },
      {
        name: 'store',
        Component: BStore,
        alternatives: ['shopping', 'market'],
        modes: ['normal', 'fill', 'alt', 'alt-fill'],
      },
      {
        name: 'archive',
        Component: BArchive,
        modes: ['normal', 'fill', 'box', 'box-fill'],
      },
      {
        name: 'error',
        Component: BError,
        alternatives: ['warning', 'danger'],
        modes: ['normal', 'fill', 'alt', 'alt-fill', 'circle', 'circle-fill'],
      },
      {
        name: 'plus',
        Component: BPlus,
        alternatives: ['add', 'increase'],
        modes: ['normal', 'fill', 'circle', 'circle-fill'],
      },
      {
        name: 'minus',
        Component: BMinus,
        alternatives: ['decrease'],
        modes: ['normal', 'fill', 'circle', 'circle-fill'],
      },
      {
        name: 'social-media',
        alternatives: [
          'youtube',
          'facebook',
          'instagram',
          'linkedin',
          'whatsapp',
          'twitter',
          'telegram',
          'tiktok',
          'discord',
          'reddit',
          'twitch',
        ],
        Component: BSocialMedia,
        modes: [
          'youtube',
          'facebook',
          'facebook-fill',
          'instagram',
          'instagram-fill',
          'linkedin',
          'linkedin-fill',
          'whatsapp',
          'telegram',
          'tiktok',
          'twitter',
          'discord',
          'reddit',
          'twitch',
        ],
      },
      {
        name: 'link',
        Component: BLink,
        alternatives: ['web'],
        modes: ['normal', 'unlink', 'alt', 'external'],
      },
      {
        name: 'platform',
        Component: BPlatform,
        alternatives: ['android', 'ios', 'windows'],
        modes: ['android', 'apple', 'windows'],
      },
      {
        name: 'mail',
        Component: BMail,
        alternatives: ['sign', 'inbox', 'envelope'],
        modes: ['gmail', 'send', 'voice', 'envelope', 'envelope-fill'],
      },
      {
        name: 'menu',
        Component: BMenu,
        modes: ['normal', 'alt-left', 'alt-right'],
      },
      {
        name: 'dots',
        Component: BDots,
        alternatives: ['more', 'options'],
        modes: [
          'horizontal',
          'horizontal-rounded',
          'vertical',
          'vertical-rounded',
        ],
      },
      {
        name: 'cog',
        Component: BCog,
        alternatives: ['settings'],
        modes: ['normal', 'fill'],
      },
    ],
  },
  /**
   * Feather section
   */
  {
    pack: 'Feather',
    icons: [
      {
        name: 'chevron-up',
        Component: FeChevronUp,
        modes: ['single', 'double'],
      },
      {
        name: 'chevron-left',
        Component: FeChevronLeft,
        modes: ['single', 'double'],
      },
      {
        name: 'chevron-right',
        Component: FeChevronRight,
        modes: ['single', 'double'],
      },
      {
        name: 'chevron-down',
        Component: FeChevronDown,
        modes: ['single', 'double'],
      },
      {
        name: 'home',
        Component: FeHome,
        alternatives: ['house'],
      },
      {
        name: 'search',
        Component: FeSearch,
        alternatives: ['find'],
      },
      {
        name: 'user',
        Component: FeUser,
        modes: ['normal', 'plus', 'minus', 'x', 'check', 'users'],
        alternatives: ['person'],
      },
      {
        name: 'image',
        Component: FeImage,
        alternatives: ['picture'],
      },
      {
        name: 'x',
        Component: FeX,
        modes: ['normal', 'circle', 'square', 'octagon'],
        alternatives: ['close', 'block'],
      },
      {
        name: 'message',
        Component: FeMessage,
        modes: ['circle', 'square'],
        alternatives: ['chat'],
      },
      {
        name: 'send',
        Component: FeSend,
      },
      {
        name: 'camera',
        Component: FeCamera,
        modes: ['normal', 'off'],
        alternatives: ['capture'],
      },
      {
        name: 'video',
        Component: FeVideo,
        modes: ['normal', 'off', 'film'],
        alternatives: ['record', 'film'],
      },
      {
        name: 'shopping-bag',
        Component: FeShoppingBag,
        alternatives: ['buy', 'sell'],
      },
      {
        name: 'shopping-cart',
        Component: FeShoppingCart,
        alternatives: ['buy', 'sell'],
      },
      {
        name: 'chart',
        Component: FeChart,
        modes: ['normal', 'alt', 'pie'],
        alternatives: [
          'stats',
          'bar',
          'pie',
          'doughnut',
          'line',
          'network',
          'scatter',
        ],
      },
      {
        name: 'time',
        Component: FeTime,
        modes: ['normal', 'watch', 'sunrise', 'sunset'],
        alternatives: ['clock'],
      },
      {
        name: 'calendar',
        Component: FeCalendar,
        alternatives: ['event', 'date'],
      },
      {
        name: 'emoji',
        Component: FeEmoji,
        modes: ['smile', 'sad', 'meh'],
        alternatives: ['smile', 'wink', 'sad', 'meh'],
      },
      {
        name: 'bell',
        Component: FeBell,
        modes: ['normal', 'off'],
        alternatives: ['alert', 'notification'],
      },
      {
        name: 'bookmark',
        Component: FeBookmark,
        modes: ['normal', 'star'],
        alternatives: ['save', 'star'],
      },
      {
        name: 'file',
        Component: FeFile,
        modes: ['normal', 'text'],
        alternatives: ['document', 'text'],
      },
      {
        name: 'lock',
        Component: FeLock,
        modes: ['lock', 'unlock'],
      },
      {
        name: 'share',
        Component: FeShare,
        modes: ['normal', 'alt'],
      },
      {
        name: 'map',
        Component: FeMap,
        modes: ['normal', 'pin', 'navigation'],
        alternatives: ['location', 'coordinate', 'navigation'],
      },
      {
        name: 'trash',
        Component: FeTrash,
        modes: ['normal', 'fill'],
        alternatives: ['delete', 'remove'],
      },
      {
        name: 'grid',
        Component: FeGrid,
      },
      {
        name: 'thumb',
        Component: FeThumb,
        modes: ['up', 'down'],
        alternatives: ['like', 'dislike'],
      },
      {
        name: 'heart',
        Component: FeHeart,
        alternatives: ['like'],
      },
      {
        name: 'archive',
        Component: FeArchive,
      },
      {
        name: 'error',
        Component: FeError,
        modes: ['circle', 'tirangle', 'octagon'],
        alternatives: ['warning', 'danger'],
      },
      {
        name: 'plus',
        Component: FePlus,
        modes: ['normal', 'circle', 'square'],
        alternatives: ['add', 'increase'],
      },
      {
        name: 'minus',
        Component: FeMinus,
        modes: ['normal', 'circle', 'square'],
        alternatives: ['decrease'],
      },
      {
        name: 'link',
        Component: FeLink,
        modes: ['normal', 'alt', 'external'],
        alternatives: ['web'],
      },
      {
        name: 'mail',
        Component: FeMail,
        modes: ['mail', 'at-sign', 'voice', 'inbox'],
        alternatives: ['sign', 'inbox'],
      },
      {
        name: 'menu',
        Component: FeMenu,
      },
      {
        name: 'dots',
        Component: FeDots,
        alternatives: ['more', 'options'],
        modes: ['horizontal', 'vertical'],
      },
      {
        name: 'cog',
        Component: FeCog,
        alternatives: ['settings'],
      },
    ],
  },
];
